(function () {
  // Essential Estimated Delivery hardcodes "h" in its light-DOM timer.
  var blocks = new WeakSet();
  var blockSelector = 'essential-estimated-delivery-app-block';
  var hourSelector = 'timer-display.essential-estimated-delivery-counter > div:nth-of-type(2)';

  function translateHours(block) {
    block.querySelectorAll(hourSelector).forEach(function (unit) {
      if (unit.textContent.trim() === 'h' || unit.textContent === 'godz.') {
        unit.textContent = 'godz.\u00a0';
      }
    });
  }

  function observeBlocks() {
    document.querySelectorAll(blockSelector).forEach(function (block) {
      if (blocks.has(block)) return;
      blocks.add(block);

      translateHours(block);
      new MutationObserver(function () {
        translateHours(block);
      }).observe(block, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBlocks, { once: true });
  } else {
    observeBlocks();
  }

  document.addEventListener('shopify:section:load', observeBlocks);
})();
